import { z } from 'zod';

/** Client-side mirror of the API validation (the server re-validates everything). */
export const inquiryFormSchema = z.object({
  fullName: z.string().trim().min(2, 'Please enter your full name.').max(120, 'Name is too long.'),
  companyName: z.string().trim().max(160, 'Company name is too long.'),
  phone: z
    .string()
    .trim()
    .min(1, 'Please enter a phone or WhatsApp number.')
    .regex(/^\+?[0-9][0-9 ()./-]{5,23}[0-9]$/, 'Enter a valid phone number, including country code.'),
  email: z.string().trim().min(1, 'Please enter your email address.').email('Enter a valid email address.').max(254),
  country: z.string().trim().max(80),
  category: z.string().min(1, 'Choose a product category.'),
  productReference: z.string().trim().max(200),
  quantity: z.string().trim().max(120),
  customization: z.string().trim().max(2000, 'Please keep this under 2000 characters.'),
  message: z
    .string()
    .trim()
    .min(10, 'Please describe your requirements (at least 10 characters).')
    .max(5000, 'Message must be at most 5000 characters.'),
  privacyAccepted: z.boolean().refine((v) => v, 'Please accept the privacy notice to continue.'),
  website: z.string(), // honeypot
});

export type InquiryFormValues = z.infer<typeof inquiryFormSchema>;
